import { Box, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface Props {
  cancelEdit?: () => void;
  loading?: boolean;
  cancelText?: string;
  submitText?: string;
}

export default function FormButtons({
  cancelEdit,
  loading,
  cancelText,
  submitText = 'Submit',
}: Props) {
  return (
    <Box
      display="flex"
      justifyContent={cancelText ? 'flex-end' : 'flex-end'}
      sx={{
        mt: { xs: 3, sm: 4 },
        gap: 2,
        flexDirection: { xs: 'column', sm: 'row' },
        width: '100%',
      }}
    >
      {cancelText && (
        <Button
          onClick={cancelEdit}
          variant="outlined"
          color="primary"
          sx={{
            order: { xs: 2, sm: 1 },
            py: 1.5,
            width: { xs: '100%', sm: 'auto' },
            minWidth: { sm: '120px' },
            borderRadius: 2,
            borderWidth: 2,
            '&:hover': {
              borderWidth: 2,
            },
          }}
        >
          {cancelText}
        </Button>
      )}
      <LoadingButton
        loading={loading}
        type="submit"
        variant="contained"
        color="primary"
        sx={{
          order: { xs: 1, sm: 2 },
          py: 1.5,
          width: { xs: '100%', sm: 'auto' },
          minWidth: { sm: '120px' },
          borderRadius: 2,
          boxShadow: 2,
          '&:hover': {
            boxShadow: 4,
          },
        }}
      >
        {submitText}
      </LoadingButton>
    </Box>
  );
}
